import angular from 'angular';
import { ULoadingHelper } from '@updater/angular-common';
import { OffersConfig } from './offers.config';
import { OffersComponent } from './offers.component';
import { RelevantContentComponent } from '../../common/directives';
import { MoveOfferCardModule } from './move-offer-card';

export const OffersStepModule = angular
  .module('app.steps.offers', [
    MoveOfferCardModule.name,
    RelevantContentComponent.name,
    ULoadingHelper.name,
  ])
  .config(OffersConfig)
  .component('updOffers', OffersComponent);
